import { render, staticRenderFns } from "./Vehicles.vue?vue&type=template&id=c2a2953c"
import script from "./Vehicles.vue?vue&type=script&lang=js"
export * from "./Vehicles.vue?vue&type=script&lang=js"
import style0 from "./Vehicles.vue?vue&type=style&index=0&id=c2a2953c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports